export const ADD_FUTURE_PAID_ITEM = "ADD_FUTURE_PAID_ITEM"
export const REMOVE_FUTURE_PAID_ITEM = "REMOVE_FUTURE_PAID_ITEM"
export const ADD_FUTURE_PAID_ITEMS = "ADD_FUTURE_PAID_ITEMS"
export const FETCH_FUTURE_PAID_ITEMS = "FETCH_FUTURE_PAID_ITEMS"
